var koKR = {
	"codeBlock.copied": "복사됨",
	"codeBlock.copyLabel": "복사",
	"inlineCodeBlock.copied": "복사됨",
	"inlineCodeBlock.copyLabel": "인라인 코드 복사"
};

export { koKR as default };
